import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Login/Login.scss";
import axiosClient from "../../axiosClient";
import { brand, brandLogos, platform } from "../../brand";

export const ForgotPassword = (): JSX.Element => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError("");
    setIsSubmitting(true);

    try {
      await axiosClient.post("/auth/forgot-password", {
        email: email.trim(),
        platform,
      });
      setSubmittedEmail(email.trim());
      setIsSuccess(true);
    } catch {
      setSubmitError(
        "Something went wrong. Please try again in a few minutes.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page" id="forgotPasswordPage">
      <div className="login-card">
        <Link to="/" className="login-logo" aria-label={`${brand.displayName} home`}>
          <img src={brandLogos.color} alt={brand.displayName} />
        </Link>
        {!isSuccess && (
          <p className="login-tagline">Reset your password</p>
        )}

        {isSuccess ? (
          <div className="login-success-state">
            <p className="login-success-panel" role="status">
              Please now check your email. If an account exists for that email, you should receive a password
              reset link shortly.
            </p>
            <Link to="/login" className="login-submit">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                type="email"
                placeholder="Enter your account email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setSubmitError("");
                }}
                autoComplete="email"
                autoFocus
                required
              />
            </div>

            {submitError && (
              <p className="login-error" role="alert">
                {submitError}
              </p>
            )}

            <button
              type="submit"
              className="login-submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        {!isSuccess && (
          <p className="login-footer">
            <Link to="/login">Back to sign in</Link>
          </p>
        )}
      </div>
    </div>
  );
};
